import React from "react";
import { Phone, WhatsappLogo } from "@phosphor-icons/react";

/**
 * The trio of primary contact CTAs — Phone, WhatsApp, plus a strapline.
 * Rendered on both Home and /aruba heroes. Copy states the payoff, not the action.
 * All three CTAs kept at the same visual prominence tier per spec.
 */
export default function ContactCTAs({ tracking, className = "" }) {
  if (!tracking) return null;
  const telHref = `tel:${tracking.number_e164}`;
  const wa = tracking.whatsapp_e164 || tracking.number_e164;
  const waHref = `https://wa.me/${wa.replace(/[^\d]/g, "")}?text=${encodeURIComponent(
    "Hi LocalRida — I'd like to book a private transfer in Aruba."
  )}`;
  return (
    <div className={className} data-testid="contact-ctas">
      <div className="grid sm:grid-cols-2 gap-4">
        <a
          href={telHref}
          data-testid="cta-phone"
          className="group flex items-start gap-4 p-5 border border-gold-bright/50 bg-navy/40 text-offwhite hover:bg-gold-bright hover:text-navy-deep transition-colors"
        >
          <Phone size={28} weight="thin" className="shrink-0 mt-1 text-gold-bright group-hover:text-navy-deep transition-colors" />
          <div>
            <div className="text-[10px] uppercase tracking-[0.28em] text-gold-bright group-hover:text-navy-deep/70">Call now</div>
            <div className="font-display text-2xl leading-tight" data-testid="cta-phone-number">{tracking.display}</div>
            <div className="text-xs text-offwhite/70 group-hover:text-navy-deep/70 mt-1">A driver confirmed in minutes</div>
          </div>
        </a>
        <a
          href={waHref}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="cta-whatsapp"
          className="group flex items-start gap-4 p-5 border border-teal-bright/60 bg-navy/40 text-offwhite hover:bg-teal-bright hover:text-navy-deep transition-colors"
        >
          <WhatsappLogo size={28} weight="thin" className="shrink-0 mt-1 text-teal-bright group-hover:text-navy-deep transition-colors" />
          <div>
            <div className="text-[10px] uppercase tracking-[0.28em] text-teal-bright group-hover:text-navy-deep/70">WhatsApp us</div>
            <div className="font-display text-2xl leading-tight">Quick reply, no app needed</div>
            <div className="text-xs text-offwhite/70 group-hover:text-navy-deep/70 mt-1">Works on airport &amp; hotel WiFi</div>
          </div>
        </a>
      </div>
      <div className="mt-4 text-[11px] uppercase tracking-[0.28em] text-offwhite/60" data-testid="cta-strapline">
        Book now — or reserve ahead of your trip
      </div>
    </div>
  );
}
